export default {
  getIsTotalsGeneratingInProcess(state) {
    return state.isTotalGeneratingInProcess;
  },
};
